export const SPIRE_GPT = {
  userId: "08de1d14-7b8d-4faa-8f06-c5e51be6df37",
  name: "SpireGPT",
};

export const SPIRE_ACADEMY = {
  userId: process.env.REACT_APP_ACADEMY_BOT_USER_ID?.trim().toLowerCase() ||
    "08de5732-2c6e-4ca1-8069-f15114f2c259",
  name: "Spire Academy",
};

export const isAcademyRoom = (room, peerUserId) => Boolean(room) &&
  (room.assistantuserid || peerUserId || room.userid)?.toLowerCase() === SPIRE_ACADEMY.userId;

// Starting sends a fixed message to the existing workflow. Earlier replies must
// not leave a read-only conversation without a way to contact the bot.
export const canStartAcademy = (room, groups, historyLoading = false, peerUserId) =>
  isAcademyRoom(room, peerUserId) && !historyLoading;

export const findAssistantRoom = (rooms, assistant) =>
  (rooms || []).find((room) => {
    if (room.assistantuserid) {
      return room.assistantuserid.toLowerCase() === assistant.userId;
    }
    // Support existing SpireGPT conversations during a backend rollout.
    return (
      assistant === SPIRE_GPT &&
      room.type !== "Group" &&
      room.groupname?.trim() === SPIRE_GPT.name
    );
  });

export const isAssistantRoom = (room, peerUserId) =>
  [SPIRE_GPT, SPIRE_ACADEMY].some(
    (assistant) =>
      (room?.assistantuserid || peerUserId)?.toLowerCase() === assistant.userId ||
      (assistant === SPIRE_GPT &&
        room?.type !== "Group" &&
        room?.groupname?.trim() === SPIRE_GPT.name),
  );
